package com.klantenstop.web.data.models.domain

import com.klantenstop.web.data.models.dto.responses.CuratedCityDto
import kotlinx.datetime.Instant
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toInstant

data class CuratedCity(
    val id: String,
    val slug: String,
    val name: String,
    val province: Province,
    val latitude: Double,
    val longitude: Double,
    val country: String,
    val isFeatured: Boolean,
    val createdAt: Instant,
    val updatedAt: Instant
) {
    val publicIdentifier: String get() = slug.ifEmpty { id }
}

fun CuratedCityDto.toCuratedCity() = CuratedCity(
    id = id,
    slug = slug,
    name = name,
    // Fail explicitly rather than silently defaulting to a province
    province = Province.fromSlug(province)
        ?: error("Unknown province slug '$province' for curated city '$id'. Backend and frontend Province enums are out of sync."),
    latitude = latitude,
    longitude = longitude,
    country = country,
    isFeatured = isFeatured,
    createdAt = LocalDateTime.parse(createdAt).toInstant(TimeZone.UTC),
    updatedAt = LocalDateTime.parse(updatedAt).toInstant(TimeZone.UTC)
)
